import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  isSupported,
  getToken,
  onMessage,
} from 'firebase/messaging';
import { messagingConfig } from './global/globalSettings';
import { amplifyApi } from './hooks/amplifyApi';
import { api } from './redux/rtk/api';
import store from './redux/store';

const ONE_WEEK_IN_MS = 604800000;
let token;
export let messaging;

export const initFCM = async () => {
  if (process.env.NODE_ENV === 'test') return messaging;

  if (!messaging) {
    const isBrowserSupported = await isSupported().catch(() => false);

    if (isBrowserSupported) {
      const firebaseApp = initializeApp(messagingConfig.firebase);

      messaging = getMessaging(firebaseApp);

      onMessage(messaging, ({ data }) => {
        const { msgType, notificationId, ...body } = JSON.parse(
          data['pinpoint.jsonBody']
        );
        const personId = store.getState().userData.person.personId;
        store.dispatch(
          api.util.updateQueryData(
            'getNotifications',
            { personId },
            previousData => {
              previousData.notifications.unshift({
                type: msgType,
                readOn: null,
                notificationId,
                payload: {
                  ...body,
                },
              });
              previousData.extraValues.totalUnreadNotifications++;
            }
          )
        );
      });
    }
  }

  return messaging;
};

const LAST_NOTIFICATION_SUBSCRIPTION_TIME =
  'LAST_NOTIFICATION_SUBSCRIPTION_TIME';

export const refreshSubscriptionToFCM = async () => {
  const lastUpdate = localStorage.getItem(LAST_NOTIFICATION_SUBSCRIPTION_TIME);
  if (!lastUpdate || Date.now() - +lastUpdate >= ONE_WEEK_IN_MS)
    await subscribeToFCM();
};

export const subscribeToFCM = async () => {
  if (!messaging) return false;

  try {
    token = await getToken(messaging, messagingConfig.webPushCertificates);

    const body = {
      token,
      platformType: 'web',
      os: 'windows',
    };

    await amplifyApi(body, '/messages/devices/subscriptions', 'put');
    localStorage.setItem(LAST_NOTIFICATION_SUBSCRIPTION_TIME, Date.now());
  } catch (err) {} // eslint-disable-line no-empty

  return !!token;
};
